export interface PaymentMethod {
  alt: string
  slug: string
  hideInBookingSolution?: boolean
}

export const PAYMENT_METHODS: PaymentMethod[] = [
  {
    alt: 'Mastercard',
    slug: 'mastercard',
  },
  {
    alt: 'Visa',
    slug: 'visa',
  },
  {
    alt: 'Paypal',
    slug: 'paypal',
  },
  // {
  //   alt: 'American Express',
  //   slug: 'amex',
  // },
  // {
  //   alt: 'Discover',
  //   slug: 'discover',
  // },
  {
    alt: 'Apple Pay',
    slug: 'apple-pay',
  },
  {
    alt: 'Google Pay',
    slug: 'google-pay',
  },
  {
    alt: 'Rechnung',
    slug: 'rechnung',
    hideInBookingSolution: true,
  },
]

/**
 * Get payment methods filtered by checkout context
 * @param isBookingSolution - Whether the checkout is booking solution (embedded or subdomain)
 * @returns Filtered array of payment methods
 */
export const getFilteredPaymentMethods = (
  isBookingSolution: boolean = false
): PaymentMethod[] => {
  if (!isBookingSolution) {
    return PAYMENT_METHODS
  }

  return PAYMENT_METHODS.filter((method) => !method.hideInBookingSolution)
}
